import React, { useState, useEffect } from 'react';
import { ENDPOINTS } from '@/config/endpoints';
import { useRouter } from 'next/router';
import axios from 'axios';
import { pushCleverTapEvent } from '../pushCleverTapEvent';

const ArticlesCategories = () => {
  const router = useRouter();
  const { locale } = router;
  const [categories, setCategories] = useState([]);
  const [mWidth, setMWidth] = useState(0);
  const [selectedCategoryId, setSelectedCategoryId] = useState(() => {
    if (typeof window !== 'undefined') {
      return parseInt(localStorage.getItem('selectedCategoryId')) || null;
    }
    return null;
  });
  const [industryCategories, setIndustryCategories] = useState([]);

  useEffect(() => {
    setMWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${locale === 'es-mx'? ENDPOINTS.SPANISH_CATEGORIES : ENDPOINTS.BLOG_CATEGORIES}`);
        setCategories(res.data.data);
      } catch (error) {
        console.error('Error:', error);
      }
    };
    fetchCategories();
  }, [locale]);

   useEffect(() => {
    const fetchIndustryCategories = async () => {
      try {
        const res = await axios.get(`${ENDPOINTS.INDUSTRY_CATEGORIES}`);
        setIndustryCategories(res.data.data);
      } catch (error) {
        console.error('Error fetching industry categories:', error);
      }
    };
    fetchIndustryCategories();
  }, [locale]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('selectedCategoryId', selectedCategoryId);
    }
  }, [selectedCategoryId]);
  
  useEffect(() => {
    const { query } = router;
    if (query.slug) {
      setSelectedCategoryId(query.slug);
    }
    else{
      setSelectedCategoryId(null);
    }
  }, [router.query]);

  const handleChange = (e) => {
    const selectedSlug = e.target.value;
    setSelectedCategoryId(selectedSlug);
    if (selectedSlug === 'all') {
      router.push('/articles');
      return;
    }
    const category =
      categories.find(cat => cat.slug === selectedSlug) ||
      industryCategories.find(cat => cat.slug === selectedSlug);
    if (category) {
      router.push(`/articles/category/${category.slug}`);
    }
  };
  
  return (
    <>
      {categories && categories.length > 0 && mWidth < 767 && industryCategories.length > 0 && (
        <select
          className='text-[12px] text-brand bg-[#fff] rounded-md py-[10px] px-[5px] w-full border border-brand h-[40px]'
          value={selectedCategoryId || 'default'}
          onChange={handleChange}>
          {locale == 'es-mx' ? <>
            <option value='default' disabled>Seleccione una categoría</option>
            <option value='all'>Todas las categorias</option>
          </> : <>
          <option value='default' disabled>Select a category</option>
          <option value='all'>All Categories</option>
          </>}
          {categories.filter(category => category.slug && category.name)
           .map((category, index) => (
             <option key={index} value={category.slug}>
               {category.name}
             </option>
           ))}
          {/* Industry specific Categories */}
         {locale === 'en-in' && industryCategories.length > 0 && <>
          <option value='default' disabled className="text-secondary font-bold">Industry</option> 
          {industryCategories.filter(category => category.slug && category.name).map((category, index) => (
           <option key={index} value={category.slug}>{category.name}</option>
         ))}
         </>}
        </select>
      )}

      {categories && categories.length > 0 && mWidth > 767 && (
        <div className="bg-[#fff] py-2">
          <ul>
            <li
              className={selectedCategoryId === null ? 'text-brand font-bold cursor-pointer mb-1 whitespace-nowrap text-sm' : 'cursor-pointer mb-1 whitespace-nowrap text-sm'}
              onClick={() => {
                setSelectedCategoryId(null);
                router.push('/articles');
                pushCleverTapEvent("Blog_Category",{"PageName": 'Blog_Page', "Category": 'all', 'userProperties': 'last_blog_category_viewed'})
              }}
            >
                {locale == 'en-in' && <>All Categories</>}
                {locale == 'es-mx' && <>Todas las categorias</>}
            </li>
            {categories.map((category, id) => (
              <li
                key={id}
                className={(selectedCategoryId === category.slug ) ? 'text-brand font-bold cursor-pointer mb-1 whitespace-nowrap text-sm' : 'cursor-pointer mb-1 whitespace-nowrap text-sm'}
                onClick={() => {
                  setSelectedCategoryId(category.slug);
                  router.push(`/articles/category/${category.slug}`);
                 pushCleverTapEvent("Blog_Category",{"PageName": 'Blog_Page', "Category": category.slug, 'userProperties': 'last_blog_category_viewed'})
                }}
              >
                {category.name}
              </li>
            ))}

            {/* Industry specific Categories */}
            {locale == 'en-in' && industryCategories.length > 0 && <>
            <h2 className="text-xl mb-1 mt-2 font-bold">Industry</h2>
             {industryCategories.map((category, id) => (
              <li
                key={id}
                className={(selectedCategoryId === category.slug ) ? 'text-brand font-bold cursor-pointer mb-1 whitespace-nowrap text-sm' : 'cursor-pointer mb-1 whitespace-nowrap text-sm'}
                onClick={() => {
                  setSelectedCategoryId(category.slug);
                  router.push(`/articles/category/${category.slug}`);
                  pushCleverTapEvent("Blog_Industry",{"PageName": 'Blog_Page', "Category": category.slug})
                }}
              >
                {category.name}
              </li>
            ))}
            </>}
          </ul>
        </div>
      )}
    </>
  );
};

export default ArticlesCategories;